import React from "react";
import DateToday from "./DateToday";

export default function TopTitleBanner(props) {
  return (
    <div className="main-top-title-banner-container">
      <div className="date-container">
        <DateToday />
      </div>
      <div className="title-text-banner">{props.title}</div>
    </div>
  );
}
